module.exports = __webpack_public_path__ + "img/logo-icon.c8b2a894.png";